import React from 'react';

const ValidationMessage = ({
  message,
  className = 'alert alert-danger w-100',
  role = 'alert',
}) => {
  if (!message) {
    return null;
  }

  return (
    <div className={className} role={role}>
      {message}
    </div>
  );
};

export default ValidationMessage;